var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85547 12C9.85547 13.2405 10.865 14.25 12.1055 14.25C13.346 14.25 14.3555 13.2405 14.3555 12C14.3555 10.7595 13.346 9.75 12.1055 9.75C10.865 9.75 9.85547 10.7595 9.85547 12Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85547 19.5C9.85547 20.7405 10.865 21.75 12.1055 21.75C13.346 21.75 14.3555 20.7405 14.3555 19.5C14.3555 18.2595 13.346 17.25 12.1055 17.25C10.865 17.25 9.85547 18.2595 9.85547 19.5Z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85547 4.5C9.85547 5.7405 10.865 6.75 12.1055 6.75C13.346 6.75 14.3555 5.7405 14.3555 4.5C14.3555 3.2595 13.346 2.25 12.1055 2.25C10.865 2.25 9.85547 3.2595 9.85547 4.5Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots1);
export default __webpack_public_path__ + "static/media/dots1.6a9b786e59d238342e497da7c1f13fe7.svg";
export { ForwardRef as ReactComponent };